import React, { FC, PropsWithChildren } from 'react';

export const ResultsContent: FC<PropsWithChildren> = ({ children }) => {
  return <div id="filterPanelPageContentResults">{children}</div>;
};
